import styles from "./modal-layout.module.css";
import cx from "classnames";

export default ({ title, onSubmit, onCancel, buttons, closeFit, children, className }) => {
    if(!buttons) {
        buttons = [];
        if(onCancel) {
            buttons.push({
                text: "Cancel",
                onClick: onCancel
            });
        }
        if(onSubmit) {
            buttons.push({
                text: "OK",
                primary: true,
                onClick: onSubmit
            });
        }
    }
    return (
        <div className={cx(styles.root, { [ styles.spacing ] : !closeFit })}>
            { title && <h3>{ title }</h3> }
            <div className={cx(styles.content, className)}>
                { children }
            </div>
            { buttons.length > 0 &&
            <div className={styles.actions}>
                { buttons.map(button =>
                    <button
                        onClick={button.onClick}
                        className={cx({
                            primary: button.primary,
                            danger: button.danger
                        })}
                        disabled={button.disabled}
                    >
                        {button.text}
                    </button>
                ) }
            </div>
        }
        </div>
    );
}

export const smallModal = {
    content: {
        maxWidth: "30rem",
        width: "90%",
        maxHeight: "80vh",
        height: "fit-content",
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0'
    },
    overlay: {
        zIndex: '1000'
    }
};

export const mediumModal = {
    content: {
        maxWidth: "50rem",
        width: "90%",
        maxHeight: "80vh",
        height: "fit-content",
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0'
    },
};

export const largeModal = {
    content: {
        maxWidth: "70rem",
        width: "95%",
        maxHeight: "90vh",
        height: "fit-content",
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0'
    },
};
